import { hot } from "react-hot-loader";

import React from "react";
import PropTypes from "prop-types";

import RouteLogin from "../RouteLogin";

class App extends React.Component {
  static defaultProps = {
    showGoogle: false,
    siteKey: ""
  };

  static propTypes = {
    showGoogle: PropTypes.bool,
    siteKey: PropTypes.string
  };

  state = {};

  render() {
    return (
      <RouteLogin
        showGoogle={this.props.showGoogle}
        siteKey={this.props.siteKey}
      />
    );
  }
}

export default hot(module)(App);
